/** Fired by a keyboard shortcut to open the picker the Import button opens. */
export const OPEN_PICKER_EVENT = 'fdv:open-import-picker';

/**
 * Opens the file picker as if Import had been pressed. Only from a key or
 * click handler: a browser opens a picker only in response to one.
 */
export function openImportPicker(): void {
  window.dispatchEvent(new Event(OPEN_PICKER_EVENT));
}
